import { WellBase } from './base/well-base';

export class Well extends WellBase { }